export const columnLabels = {
    id: 'ID',
    full_name: 'ФИО',
    phone_number: 'Номер телефона',
    salary_range: 'Ожидаемая зарплата',
    resume_uuid: 'Резюме',
    work_permit: 'Разрешение на работу',
    migration: 'Миграция',
    employment: 'Тип занятости',
    specializations: 'Специализации',
    salary: 'Желаемый уровень дохода',
    salary_currency: 'Валюта зарплаты',
    summary_experience: 'Суммарный опыт',
    experiences: 'Опыт работы',
    skills: 'Навыки',
    driving_experience: 'Водительский стаж',
    about_candidate: 'О кандидате',
    high_education: 'Высшее образование',
    additional_education: 'Дополнительное образование',
    examinations: 'Сертификации / экзамены',
    city: 'Город',
    citizenship: 'Гражданство',
    email: 'Email',
    another_contacts: 'Доп. контакты',
    languages: 'Языки',
    created_at: 'Дата создания',
    status: 'Статус',
    completion_work: 'Дата завершения',
    result_candidate: 'Результат собеседования',
    failure_reason: 'Причина отказа',
    files: 'Резюме',
    vacancy_id: 'Вакансия',
    vacancy_and_status: 'Вакансия и статус',
    actions: 'Действия',
};

export const STATUSES = {
    new: {
        title: 'Новые',
        color: '#1890ff' // Синий - новые кандидаты
    },
    call_back: {
        title: 'Перезвонить',
        color: '#13c2c2' // Голубой - требует действия
    },
    interview: {
        title: 'Собеседование',
        color: '#fa8c16' // Оранжевый - активный процесс
    },
    references: {
        title: 'Сбор рекомендаций',
        color: '#faad14' // Желтый - проверка
    },
    offer: {
        title: 'Предложение о работе',
        color: '#722ed1' // Фиолетовый - важный этап
    },
    documentation: {
        title: 'Оформление документов',
        color: '#eb2f96' // Розовый - финальный этап
    },
    hired: {
        title: 'Завершенный',
        color: '#1890ff' // Зеленый - успех
    },
    failed: {
        title: 'Отклонён',
        color: '#f5222d' // Красный - неудача
    }
};

export const FAILURE_REASONS = {
    'no_show': 'Не пришел на собеседование',
    'irrelevant_experience': 'Нерелевантный опыт работы',
    'irrelevant_salary': 'Нерелевантный доход',
    'no_contact': 'Не выходит на связь',
    'not_interested_product': 'Не интересен товар',
    'unsuitable_schedule': 'Не подходит график работы',
    'not_actively_searching': 'Не актуален поиск работы',
    'not_interested_functionality': 'Не интересен функционал',
    'long_commute': 'Далеко добираться',
    'failed_test_assignment': 'Не прошел тестовое задание',
    'vacancy_closed': 'Вакансия закрыта',
    'other_requirements': 'Не подходит по другим требованиям'
};

